export default function Button({ variant = 'primary', className = '', href, type = 'button', ...props }) {
  const base =
    'inline-flex items-center justify-center rounded-lg px-4 py-3 md:py-2 text-base md:text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-200 transform-gpu disabled:cursor-not-allowed disabled:opacity-60 hover:-translate-y-0.5 hover:shadow-md disabled:hover:shadow-none disabled:hover:translate-y-0';
  const map = {
    primary: 'bg-cam-blue text-white hover:bg-[#1f3e66] focus:ring-cam-blue',
    secondary: 'bg-white text-cam-blue border border-cam-blue hover:bg-cam-blue hover:text-white focus:ring-cam-blue',
    ghost: 'bg-transparent text-cam-blue hover:bg-cam-blue/10 focus:ring-cam-blue'
  };
  const classes = `${base} ${map[variant] ?? map.primary} ${className}`.trim();

  if (href) {
    return <a className={classes} href={href} {...props} />;
  }

  return <button className={classes} type={type} {...props} />;
}
